module.exports = __webpack_public_path__ + "static/media/polizia.d398bdac.png";